//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import { AutoActiveConfigRules } from '@streams/components/AutoActiveConfigRules';

angular.module('curalate').component('autoConfigTbb', {
  controller: makeAngularReactController(<AutoActiveConfigRules />),
});
